
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-without-borders",
      function () {
        return require("private-next-pages/design-without-borders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-without-borders"])
      });
    }
  